export const favourite = {
    body: {
        width: 20,
        height: 20,
        lineHeight: "1",
    },
};
